import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import {
  Table,
  TableBody,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Rating,
  IconContainerProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface EvaluationFeedbackResponseProps {
  feedbackResponseData: any;
}

const ratingMapping = {
  'Extremely poor': 1,
  Poor: 2,
  Good: 3,
  'Very good': 4,
  Excellent: 5,
};

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));

const customIcons: {
  [index: string]: {
    icon: React.ReactElement<any>;
    label: string;
  };
} = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon color="error" />,
    label: 'Very Dissatisfied',
  },
  2: {
    icon: <SentimentDissatisfiedIcon color="error" />,
    label: 'Dissatisfied',
  },
  3: {
    icon: <SentimentSatisfiedIcon color="warning" />,
    label: 'Neutral',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon color="success" />,
    label: 'Satisfied',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon color="success" />,
    label: 'Very Satisfied',
  },
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

const SubmissionCandidateEvalutationView: React.FC<EvaluationFeedbackResponseProps> = ({
  feedbackResponseData,
}) => {
  const CandidateResponseCard = ({ dataValue, index }) => {
    const answer = typeof dataValue.ans === 'object' ? dataValue.ans.answer : dataValue.ans;
    const type = typeof dataValue.ans === 'object' ? dataValue?.ans.type : '';
    const ratingSubType = typeof dataValue.ans === 'object' ? dataValue?.ans.subType : '';
    let downloadFileName = '';
    if (type === 'file') {
      downloadFileName = answer?.split(';')?.[0]?.split('/')?.[1];
    }
    if (typeof answer === 'string' && answer.includes('base64')) {
      return (
        <>
          <TableRow key={index}>
            <TableCell>{dataValue.ques as string}</TableCell>
            <>
              {answer.includes('text/plain') && type !== 'file' && (
                <TableCell>
                  <object type="text/plain" data={JSON.stringify(answer)}>
                    {'click'}
                  </object>
                </TableCell>
              )}
              {answer.includes('application/pdf') && type !== 'file' && (
                <TableCell>
                  <object type="application/pdf" data={answer}>
                    {'click'}
                  </object>
                </TableCell>
              )}
              {type === 'file' && (
                <TableCell>
                  <a download={`download.${downloadFileName}`} href={answer}>
                    Download File
                  </a>
                </TableCell>
              )}
              {answer.includes('data:image') && type !== 'file' && (
                <TableCell>
                  <img alt="SuraveyDoc" src={answer}></img>
                </TableCell>
              )}
            </>
          </TableRow>
        </>
      );
    } else {
      return (
        <>
          <TableRow key={index}>
            <TableCell>{dataValue.ques as string}</TableCell>
            <TableCell>
              {type === 'rating' ? (
                ratingSubType === '' ? (
                  answer
                ) : ratingSubType === 'stars' ? (
                  <Rating readOnly value={ratingMapping[answer]} />
                ) : ratingSubType === 'smileys' ? (
                  <StyledRating
                    name="highlight-selected-only"
                    defaultValue={2}
                    IconContainerComponent={IconContainer}
                    getLabelText={(value: number) => customIcons[value].label}
                    highlightSelectedOnly
                    readOnly
                  />
                ) : (
                  JSON.stringify(answer)
                )
              ) : (
                JSON.stringify(answer)
              )}
            </TableCell>
          </TableRow>
        </>
      );
    }
  };
  return (
    <>
      <TableContainer component={Paper}>
        <Table className="styled-table" aria-label="customized table">
          <TableHead>
            <TableRow>
              <TableCell>Question</TableCell>
              <TableCell>Answer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(feedbackResponseData) &&
              feedbackResponseData.map((data, index) => (
                <>
                  <CandidateResponseCard dataValue={data} index={index} />
                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SubmissionCandidateEvalutationView;
